export const setRoomName = (name) => ({
  type: "SET_ROOM_NAME",
  payload: { name },
});

export const setRoomState = (state) => ({
  type: "SET_ROOM_STATE",
  payload: { state },
});

export const setRoomActiveSpeaker = (peerId) => ({
  type: "SET_ROOM_ACTIVE_SPEAKER",
  payload: { peerId },
});

export const setRoomLocked = () => ({
  type: "SET_ROOM_LOCKED",
});

export const setRoomUnLocked = () => ({
  type: "SET_ROOM_UNLOCKED",
});

export const setInLobby = (inLobby) => ({
  type: "SET_IN_LOBBY",
  payload: { inLobby },
});

export const setSignInRequired = (signInRequired) => ({
  type: "SET_SIGN_IN_REQUIRED",
  payload: { signInRequired },
});

export const setAccessCode = (accessCode) => ({
  type: "SET_ACCESS_CODE",
  payload: { accessCode },
});

export const setJoinByAccessCode = (joinByAccessCode) => ({
  type: "SET_JOIN_BY_ACCESS_CODE",
  payload: { joinByAccessCode },
});

export const setSettingsOpen = ({ settingsOpen }) => ({
  type: "SET_SETTINGS_OPEN",
  payload: { settingsOpen },
});

export const setStartLiveStreamingDialogOpen = ({
  startLiveStreamingDialogOpen,
}) => ({
  type: "SET_START_LIVE_STREAMING_DIALOG_OPEN",
  payload: { startLiveStreamingDialogOpen },
});

export const setLeaveDialogOpen = ({ leaveDialogOpen }) => ({
  type: "SET_LEAVE_DIALOG_OPEN",
  payload: { leaveDialogOpen },
});

export const setFileSharingSupported = (supported) => ({
  type: "FILE_SHARING_SUPPORTED",
  payload: { supported },
});

export const toggleConsumerWindow = (consumerId) => ({
  type: "TOGGLE_WINDOW_CONSUMER",
  payload: { consumerId },
});

export const setToolbarsVisible = (toolbarsVisible) => ({
  type: "SET_TOOLBARS_VISIBLE",
  payload: { toolbarsVisible },
});

export const setDisplayMode = (mode) => ({
  type: "SET_DISPLAY_MODE",
  payload: { mode },
});

export const setSelectedPeer = (selectedPeerId) => ({
  type: "SET_SELECTED_PEER",
  payload: { selectedPeerId },
});

export const setSpotlights = (spotlights) => ({
  type: "SET_SPOTLIGHTS",
  payload: { spotlights },
});

export const toggleJoined = () => ({
  type: "TOGGLE_JOINED",
});

export const toggleConsumerFullscreen = (consumerId) => ({
  type: "TOGGLE_FULLSCREEN_CONSUMER",
  payload: { consumerId },
});

export const switchConsumerFullscreen = (consumerId) => ({
  type: "SWITCH_FULLSCREEN_CONSUMER",
  payload: { consumerId },
});

export const setMuteAllInProgress = (flag) => ({
  type: "MUTE_ALL_IN_PROGRESS",
  payload: { flag },
});

export const setStopAllVideoInProgress = (flag) => ({
  type: "STOP_ALL_VIDEO_IN_PROGRESS",
  payload: { flag },
});

export const setCloseMeetingInProgress = (flag) => ({
  type: "CLOSE_MEETING_IN_PROGRESS",
  payload: { flag },
});

export const setUserRoles = (userRoles) => ({
  type: "SET_USER_ROLES",
  payload: { userRoles },
});

export const setPermissionsFromRoles = (permissionsFromRoles) => ({
  type: "SET_PERMISSIONS_FROM_ROLES",
  payload: { permissionsFromRoles },
});

export const setRoomWebinar = (flag) => ({
  type: "SET_ROOM_WEBINAR",
  payload: { flag },
});

export const setRoomRecordingState = (state) => ({
  type: "SET_ROOM_RECORDING_STATE",
  payload: { state },
});

export const setRecordingNotificationStatus = (
  recordingNotificationStatus
) => ({
  type: "SET_RECORDING_NOTIFICATION_STATUS",
  payload: { recordingNotificationStatus },
});

export const setLiveStreamingNotificationStatus = (
  liveStreamingNotificationStatus
) => ({
  type: "SET_LIVE_STREAMING_NOTIFICATION_STATUS",
  payload: { liveStreamingNotificationStatus },
});

export const setStartTime = (startTime) => ({
  type: "SET_START_TIME",
  payload: { startTime },
});

export const clearState = () => ({
  type: "CLEAR_STATE",
});

export const setOfficialReportOpenGlobal = (isOpen) => ({
  type: "IS_OFFICIAL_REPORT_OPEN_GLOBAL",
  payload: isOpen,
});
